import { Component, inject, Input } from '@angular/core';
import { map, Observable } from 'rxjs';
import { WucFormErrorModule, WucInputAlertModule } from '@inshared/website-ui-components';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { OutValidationModule,  ValidationDataService } from 'outshared-lib/validation';
import { ErrorInterface } from 'outshared-lib/core/interfaces';

@Component({
    standalone: true,
    selector: 'ins-element-validate-errors',
    templateUrl: 'element-validate-errors.component.html',
    imports: [
        AsyncPipe,
        NgForOf,
        NgIf,
        OutValidationModule,
        WucFormErrorModule,
        WucInputAlertModule,
    ]
})

export class ElementValidateErrorsComponent {
    @Input() set name(name: string) {
        this.errors$ = this.#validationDataService.getErrors$(name).pipe(
            map((errors: ErrorInterface[]) => errors.map((error: ErrorInterface) => error.message))
        );
    }

    readonly #validationDataService: ValidationDataService = inject(ValidationDataService);

    public errors$!: Observable<string[]>;

}
